module.exports = __webpack_public_path__ + "pattern8.3c3f912dbb9e7ad69b26.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/img/pattern8.png
// module id = ../../../../../src/img/pattern8.png
// module chunks = styles